import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/gy-apartment'

let api = {
  // 批量添加卡类型
  addPatchCardType: `${baseUrl}/cardType/addPatch`,

  // 添加卡类型账户
  deleteCardTypeByCodes: `${baseUrl}/cardType/deleteByCodes`,

  // 获取卡类型分页
  getCardTypePage: `${baseUrl}/cardType/getPage`,

  // 获取卡类型列表
  getCardTypeList: `${baseUrl}/cardType/getList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigCardType.js